import { PaletteMode } from '@mui/material';
import { RecoilState, atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
    key: 'theme',
    storage: localStorage,
    converter: JSON,
});

// Atom to hold the theme state
export const themeState: RecoilState<PaletteMode> = atom({
    key: 'themeState',
    default: 'dark',
    effects: [persistAtom],
});
